import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C28RichTextWithCTAProps = RenderingProps<
  C28RichTextWithCTAFields,
  C28RichTextWithCTAParams
>;

export type C28RichTextWithCTAFields = {
  FirstCta?: LinkField;
  Headline?: Field<string>;
  SecondCta?: LinkField;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
};

export type C28RichTextWithCTAParams = {
  BackgroundColor?: string;
  HeadlineTag?: string;
  SecondCtaStyle?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
